import HeroSection from "@/components/home/HeroSection";
import Marquee from "@/components/Marquee";
import CernioFeature from "@/components/home/CernioFeature";
import WhyGadulabs from "@/components/home/WhyGadulabs";
import ProductsSection from "@/components/home/ProductsSection";
import TechnologySection from "@/components/home/TechnologySection";
import AboutSection from "@/components/home/AboutSection";
import DarkCTA from "@/components/home/DarkCTA";

export default function Home() {

  return (
    <>
      <HeroSection />
      <Marquee />
      <CernioFeature />
      <WhyGadulabs />
      <ProductsSection />
      <TechnologySection />
      <AboutSection />
      <DarkCTA />
    </>
  );
}
